const toBase64Url = (bytes) => {
    let binary = '';
    bytes.forEach((b) => { binary += String.fromCharCode(b); });
    return btoa(binary)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};

export const generateCodeVerifier = () => {
    const bytes = crypto.getRandomValues(new Uint8Array(32));
    return toBase64Url(bytes);
};

export const generateCodeChallenge = async (verifier) => {
    const encoded = new TextEncoder().encode(verifier);
    const digest = await crypto.subtle.digest('SHA-256', encoded);
    return toBase64Url(new Uint8Array(digest));
};
